/**
 * Frontline Keep delivery — user-facing glossary.
 * Technical/API names stay "Flow"; UI copy uses these labels.
 */
export const FrontlineGlossary = {
  singular: 'Guide',
  plural: 'Guides',
  create: 'Create Guide',
  createTitle: 'CREATE GUIDE',
  createSubtitle: 'Choose how you want to create your guide',
  createYour: 'Create your guide',
  smartCreateTitle: 'SMART CREATE GUIDE',
  bundleSingular: 'Guide Pack',
  bundlePlural: 'Guide Packs',
} as const;

/**
 * Soft-gate flags for creator/commerce surfaces that remain in code
 * but should not appear in the primary frontline experience.
 */
export const FrontlineFeatureFlags = {
  /** Consultations already hidden in dashboard/settings; keep false. */
  showConsultations: false,
  /** Guide top-ups, AI coins, optional add-ons on Pricing. */
  showCommerceAddOns: false,
  /** Coin purchase CTAs on create-selection. */
  showCoinPurchaseLinks: false,
  /** Paid content purchase CTAs (view/create) — soft-gated for frontline. */
  showContentPurchase: false,
} as const;
